export interface GalleryItem {
    itemType: GalleryItemType,
    thumbnailUrl: string,
    originalUrl: string,
    altText: string
}

export enum GalleryItemType {
    ytvideo = "ytvideo",
    image = "image",
    vimeo = "vimeo"
}
